var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18.023 18.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2404",
    "data-name": "Group 2404",
    transform: "translate(-56.977 -353.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_today_black_24dp_2_",
    "data-name": "calendar_today_black_24dp (2)",
    transform: "translate(56.978 353.384)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8335",
    "data-name": "Path 8335",
    d: "M0,0H18.023V18.023H0Z",
    transform: "translate(0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8336",
    "data-name": "Path 8336",
    d: "M15.517,2.5h-.751V1h-1.5V2.5H5.755V1h-1.5V2.5H3.5A1.506,1.506,0,0,0,2,4V16.019a1.506,1.506,0,0,0,1.5,1.5H15.517a1.506,1.506,0,0,0,1.5-1.5V4A1.506,1.506,0,0,0,15.517,2.5Zm0,13.517H3.5V6.257H15.517Z",
    transform: "translate(-0.498 -0.249)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "!",
    transform: "translate(64.877 366.796)",
    fontSize: 8,
    fontFamily: "Lato-Semibold, Lato",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "!")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeave);
export default __webpack_public_path__ + "static/media/leave.e30893258fa43a42eea3391a8c16146c.svg";
export { ForwardRef as ReactComponent };